function validateReservationLookupInfo(confirmationCode, lastName) {
    return (
        isValidConfirmationCode(confirmationCode) &&
        lastName &&
        lastName.length > 0
    );
}

function isValidConfirmationCode(confirmationCode) {
    return confirmationCode && confirmationCode.length >= 6;
}

//Imported by server
module.exports = { validateReservationLookupInfo, isValidConfirmationCode };
